<script setup>
import ContainerRoot from '@js/components/containers/ContainerRoot.vue';
import HtmlPreview from '@js/components/contents/HtmlPreview.vue';
import DialogModal from '@js/components/dialogs/DialogModal.vue';

const { title, html, content } = defineProps({
    title: {
        type: String,
        required: true,
    },
    html: {
        type: String,
        required: true,
    },
    content: {
        type: [String, Object],
        required: false,
    },
});
</script>

<template>
    <DialogModal size="medium">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title>
            {{ title }}
        </template>

        <template #content>
            <ContainerRoot>
                <template v-if="content">
                    <div
                        v-if="typeof content === 'string'"
                        class="wysiwyg mb-4"
                        v-html="content"
                    ></div>

                    <div v-else class="wysiwyg mb-4">
                        <component :is="content" />
                    </div>
                </template>

                <HtmlPreview :html="html" />
            </ContainerRoot>
        </template>
    </DialogModal>
</template>
